{
  "firmware": "0.6.1",
  "dashboard": "0.5.1",
  "configSchema": 1,
  "floorplanSchema": 1,
  "statsSchema": 1,
  "firmwareSecurityEpoch": 3
}
